import { render, staticRenderFns } from "./low.vue?vue&type=template&id=4b206c56"
import script from "./low.vue?vue&type=script&lang=js"
export * from "./low.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports